import type { ReactNode } from 'react';
import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

type Props = {
  children: ReactNode;
};

const DetailsListColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  gap: 16px;

  @media min-width(${cssBreakpoints.mdUp}) {
    width: 0;
  }
`;

export function DetailsListColumn({ children }: Props) {
  return <DetailsListColumnContainer>{children}</DetailsListColumnContainer>;
}
